import { render } from "./NotificationItem.vue?vue&type=template&id=3706a8e1&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=3706a8e1&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3706a8e1"]])

export default __exports__